module.exports = __webpack_public_path__ + "static/media/last-activity.09092ec2.svg";